import { getAuthSession } from '@/redux/requests/sessionRequests.js';
import loadSignedInContext from '@/redux/actions/sessionActions/loadSignedInContext.js';

/**
 * Asks the API whether this browser has a session (the cookie is http-only, so only the API knows)
 * and, when it does, loads the signed-in context. A signed-out answer settles the session as signed out.
 */
const bootstrapSession = () => {
  return async (dispatch) => {
    const session = await getAuthSession();

    if (!session || session.success === false) {
      return { success: true, data: { signedIn: false } };
    }

    return dispatch(loadSignedInContext({ companyId: session.companyId }));
  };
};

export default bootstrapSession;
